import script from "./LinkedPathsBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkedPathsBox.vue?vue&type=script&lang=ts&setup=true"

import "./LinkedPathsBox.vue?vue&type=style&index=0&id=35e5cfd3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e5cfd3"]])

export default __exports__